<script lang="ts">
  import('App/Parts').then((m) => {
    let module = m.default;

    new module({
      target: document.getElementById('parts'),
      layout: 'auto',

      props: {
        schema: {
          visibility: {
            readOnly: true,
          },
        },
      },
    });
  });
</script>

<div id="parts" />
